import { useRef } from 'react'
import { useEditor } from '../../hooks/useEditor'

export default function CodeEditor() {
  const containerRef = useRef<HTMLDivElement>(null)
  useEditor(containerRef)

  return (
    <div className="h-full w-full overflow-hidden">
      <div ref={containerRef} className="h-full w-full [&_.cm-editor]:h-full [&_.cm-scroller]:overflow-auto" />
    </div>
  )
}
